export default "__VITE_ASSET__865ecdf1__"